module.exports = __webpack_public_path__ + "img/salia.f1046543.jpg";